<template>
  <div
    v-block-loading:initFetch="loading"
    class="match-container"
  >
    <slot
      v-if="loading === false"
      :inner-loading="innerLoading"
    />
  </div>
</template>

<script>
import { storeToRefs } from 'pinia'
import { useAuthStore } from '@ms/stores/auth'
import { useGlobalConfigStore } from '@ms/stores/globalConfig'
import { useMatchDetailStore } from 'wap/stores/matchDetail'
import { useWapBetslipStore } from 'wap/stores/betslip'
import useMatchInfo from '@ms/components/match/useMatchInfo.js'
import eventBus from '@ms/utils/event-bus.js'
import { updateMatchDetailTitle } from '@ms/utils-es/seo'

export default {
  setup() {
    const auth = useAuthStore()
    const { loginStatus } = storeToRefs(auth)
    const { matchInfo, sportId } = useMatchInfo()

    const matchDetailStore = useMatchDetailStore()
    const { event, eventId, currentTab } = storeToRefs(matchDetailStore)

    const { getMatchDetail, getFavouriteMarkets, getMarketGroupList, subEvent, subMarkets, subBlacklist } = matchDetailStore

    const { selectionList } = storeToRefs(useWapBetslipStore())

    return {
      loginStatus,
      matchInfo,
      sportId,
      event,
      eventId,
      currentTab,
      getMatchDetail,
      getFavouriteMarkets,
      getMarketGroupList,
      subEvent,
      subMarkets,
      subBlacklist,
      selectionList
    }
  },
  data() {
    return {
      loading: false,
      innerLoading: false
    }
  },
  watch: {
    eventId() {
      this.initFetch()
    },
    loginStatus(val) {
      if (val) {
        this.getFavouriteMarkets(this.event.sportId)
      }
    },
    currentTab(val) {
      if (val === 'Market') {
        this.subEvent({ isSub: false })
        this.subMarkets({ isSub: false })
        this.innerLoading = true
        this.initFetch()
      }
    }
  },
  created() {
    this.initFetch()
  },
  beforeDestroy() {
    this.subEvent({ isSub: false })
    this.subMarkets({ isSub: false })
  },
  methods: {
    async initFetch() {
      if (!this.innerLoading) this.loading = true
      if (this.matchInfo.homeTeam) {
        updateMatchDetailTitle(this.matchInfo)
      }
      eventBus.$emit('update-mini-footer')
      try {
        const hasSportId = !!this.sportId
        const reqList = [this.getMatchDetail()]
        if (hasSportId) {
          reqList.push(this.getMarketGroupList(this.sportId))
        }
        await Promise.all(reqList)
        if (!hasSportId) {
          await this.getMarketGroupList(this.sportId)
        }
        updateMatchDetailTitle(this.matchInfo)
        this.subEvent()
        this.subMarkets()
        this.subBlacklistFilter()
        if (this.loginStatus) {
          this.getFavouriteMarkets(this.sportId)
        }
        this.loading = false
        this.innerLoading = false
        eventBus.$emit('update-mini-footer')
      } catch (error) {
        this.loading = -1
        this.innerLoading = false
        console.error(error)
      }
    },
    subBlacklistFilter() {
      if (!this.event.markets) return
      const { igopmsMarkets } = useGlobalConfigStore()
      // 加入黑名单规则：1、配置的igopmsMarkets presentationType != 1 且 默认为收起状态（expand = 0）;2、加入到betslip中的odds不再加入黑名单中
      const { map, order } = this.event.markets
      if (igopmsMarkets && igopmsMarkets.length && map) {
        const betslipMarket = this.betslipMarketFilter()
        igopmsMarkets.forEach((x) => {
          order.forEach((item) => {
            const orderInfo = item.toString().split('_')
            const m = map[item]
            const specifiers = m.specifiers
            const expand = m.expand
            const presentationType = m.presentationType
            if (orderInfo[0] === x && expand === 0 && presentationType !== 1 && !betslipMarket.includes(`${item}`)) {
              if (orderInfo.length > 1) {
                this.subBlacklist({ isSub: true, marketIds: [orderInfo[0]], specifiers })
              } else {
                this.subBlacklist({ isSub: true, marketIds: [orderInfo[0]] })
              }
            }
          })
        })
      }
    },
    betslipMarketFilter() {
      if (this.selectionList.length) {
        const ids = this.selectionList.map((x) => {
          const id = `${x.marketInfo.id || ''}`
          return x.marketInfo.specifiers ? `${id}_${x.marketInfo.specifiers}` : id
        })
        return [...new Set(ids)]
      }
      return []
    }
  }
}
</script>
